import React, { useState, useEffect, useContext } from 'react';
import {
  Box,
  Button, CircularProgress, Container, TextField,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import Colors from '../../../../Configs/colors';
import { useDispatch } from 'react-redux';
import PhoneInput from 'react-phone-input-2';
import Elements from '../../../Elements';
import { getUserData } from '../../../../Utils/storages';
// import ROUTES from '../../../../Configs/routes';
import { getUserData as getUser, updateUserData } from '../../../../Redux/Models/user';
import { getAddress } from '../../../../Redux/Models/address';
import AlertContext from '../../../../Context/AlertContext';
import ROUTES from '../../../../Configs/routes';

export default function UpdateProfile({
  classes, isLoading, message, error, updatedUser, data,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { openAlert } = useContext(AlertContext);
  const userData = getUserData();

  useEffect(() => {
    dispatch(getAddress(userData.id));
  }, []);

  const [submitted, setSubmitted] = useState(false);
  const [fields, setField] = useState({
    front_name: '',
    back_name: '',
    phone_number: '',
  });

  useEffect(() => {
    dispatch(getUser(userData.id));
  }, []);

  useEffect(() => {
    setField(data);
  }, [data]);

  const handleChangeField = (e) => {
    setField({ ...fields, [e.target.name]: e.target.value });
  };

  const saveData = (e) => {
    e.preventDefault();
    setSubmitted(true);
    dispatch(updateUserData(userData.id, fields));
  };

  useEffect(() => {
    if (error && submitted) {
      openAlert({
        open: true,
        severity: 'error',
        message: `Something went wrong, ${message}`,
      });
    }
  }, [error, submitted]);

  useEffect(() => {
    if (submitted && updatedUser) {
      openAlert({
        open: true,
        severity: 'success',
        message: 'User data updated',
      });
      navigate(ROUTES.profile());
    }
  }, [submitted, updatedUser]);

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <div className={classes.root}>
        <Elements.Navigator title="My profile" />

        <Box mt={2}>
          <form onSubmit={saveData}>
            <Container>
              <Box className="s-12 weight-700">
                Account Information
              </Box>

              <div className="mt-3 weight-600 s-14">First Name</div>
              <div className="mt-1">
                <TextField size="small" required value={fields.front_name} name="front_name" onChange={handleChangeField} fullWidth multiline placeholder="Type first name" />
              </div>

              <div className="mt-3 weight-600 s-14">Last Name</div>
              <div className="mt-1">
                <TextField size="small" value={fields.back_name} name="back_name" onChange={handleChangeField} fullWidth multiline placeholder="Type last name" />
              </div>

              <div className="mt-3 weight-600 s-14">Phone Number</div>
              <div className="mt-1">
                <PhoneInput
                  placeholder="Type phone number"
                  value={fields.phone_number}
                  onChange={(phone) => setField({ ...fields, phone_number: phone })}
                // autoFormat={false}
                // enableSearch
                  country="fr"
                  containerStyle={{
                    width: '100%',
                  }}
                  inputStyle={{
                    width: '100%',
                    borderRadius: 8,
                    height: 40,
                    background: '#FBFBFB',
                    border: '1px solid #F5F5F5',
                  }}
                  buttonStyle={{
                    borderTopLeftRadius: 8,
                    borderBottomLeftRadius: 8,
                    background: 'transparent',
                  }}
                />
              </div>
            </Container>

            <div className="floating-action">
              <Container>
                <Button startIcon={isLoading && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)} fullWidth type="submit" size="large" variant="contained" className="btn-contained">
                  Save new information
                </Button>
              </Container>
            </div>
          </form>
        </Box>
      </div>
    </Elements.PageBase>
  );
}
